import { BaseService } from 'src/app/base/services/base.service';
import { Topico } from '../models/chat-bot.model';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class ChatBotService extends BaseService<Topico> {

  constructor(public http: HttpClient) {
    super(http);
  }

  public perguntar(obj: Record<string, any>): Observable<any> {
    return this.http.post<any>(this.baseUrl + '/perguntar', obj, { headers: this.headers });
  }

  public getPathModule(): string {
    return '/chat-bot';
  }
}
